import { Button } from '@dealstack/frontend/shared/components/fundament/Button/Button';
import { useTransactionsActions } from './useTransactionsActions';
import { ActionButtonsWrapper, CompletedInvestmentWorkflowText } from './styled';

export const TransactionsActions = ({ investmentWorkflow, insertedTransaction }) => {
	const { revokeInvestmentWorkflowRequest, softDeleteInvestmentWorkflowRequest } =
		useTransactionsActions();

	if (investmentWorkflow?.isCompleted) {
		return (
			<>
				<CompletedInvestmentWorkflowText colorLink center>
					Transaction is completed
					{!!insertedTransaction && ' and inserted to the ledger'}
				</CompletedInvestmentWorkflowText>
				{!insertedTransaction && (
					<ActionButtonsWrapper>
						<Button
							onClick={() => {
								softDeleteInvestmentWorkflowRequest.mutate({
									investmentWorkflowId: investmentWorkflow.id,
								});
							}}
							variant="delete"
						>
							Soft delete InvestmentWorkflow
						</Button>
					</ActionButtonsWrapper>
				)}
			</>
		);
	}

	return (
		<ActionButtonsWrapper>
			<Button
				onClick={() => {
					revokeInvestmentWorkflowRequest.mutate({
						revokeInvestmentWorkflowId: investmentWorkflow.id,
					});
				}}
				variant="delete"
			>
				Revoke InvestmentWorkflow
			</Button>
		</ActionButtonsWrapper>
	);
};
